import getMetricsPublisher from './katalMetricsPublisher';

export default {
    install(app) {
        app.config.globalProperties.$metrics = getMetricsPublisher();
    },
};
